import Http from '@/sub-luca-plugin/utils/http';

// 查询项目下可购买的权益列表
export const query_purchasable_equity_list = (params: { lucaId: number; projectId: number }) =>
    Http.get('/aitutor/api/v1/front/equity/list', params);

// 获取用户名称 用户头像
export const user_info = () => Http.get('/passport/api/v3/get/glive-user-info');

// 创建商品订单
export const create_product_order = (params: {
    // studentId: stringify;
    orderSource: number;
    clueParameters: '{"lucaOrder":true}';
    productId: number;
    appId: 'wx4f1fcbd78ee2b420';
    orderPay: {
        payChannelType: 'cashier' | 'applets';
        appId?: string;
        openId?: string;
        payChannel: 'Wechat';
        payType: '148';
        payBackUrl: string;
    };
    productType: 'serviceProduct';
}) => Http.post(`/gaodun-shoping/api/v1/order/big-app/create`, params);

// 获取收银台地址
export const cashier_address = (params: { orderNo: string; returnUrl: string }) =>
    Http.post(`/gaodun-shoping/portal/v2/order/get-pay-url`, params);

// 获取购买列表
export const query_purchased_equity_list = (params: { projectId: number }) =>
    Http.get('/aitutor/api/v1/front/equity/student/equity/info', params);
